import { IAccount } from '@site-mate/sitemate-global-shared';
import { useOutletContext } from 'react-router-dom';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import CreateWorkspace from '@/components/workspace-switcher/create-workspace';
import { SignUpSidebarBackground } from '@/pages/signup/signup-sidebar-background';

interface CreateWorkspaceOutletContext {
  account: IAccount | null;
}

export const CreateWorkspacePage = () => {
  const { account } = useOutletContext<CreateWorkspaceOutletContext>();

  return (
    <SignUpSidebarBackground className="opacity-0">
      <Dialog open modal>
        <DialogContent
          className="top-0 mt-25 w-[500px] border-white"
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle hideCloseButton>Create Workspace</DialogTitle>
          </DialogHeader>

          <CreateWorkspace account={account} />
        </DialogContent>
      </Dialog>
    </SignUpSidebarBackground>
  );
};
